export default {
  
  selectedDirectory: state => state.directory,
}
